import { defineComponent as r, openBlock as n, createBlock as t, unref as a, mergeProps as i, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconCrossInCircleFilledSmall",
  __name: "IconCrossInCircleFilledSmall",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const o = l;
    return (c, e) => (n(), t(a(s), i(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.53 4.47a.75.75 0 0 0-1.06 0L12 10.94 9.53 8.47a.75.75 0 1 0-1.06 1.06L10.94 12l-2.47 2.47a.75.75 0 1 0 1.06 1.06L12 13.06l2.47 2.47a.75.75 0 0 0 1.06-1.06L13.06 12l2.47-2.47a.75.75 0 0 0 0-1.06",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
